import { FormControl, FormGroup } from '@angular/forms';
import { IManagedProductSearchParams } from './managed-product.interface';

export class ManagedProductFormModel {
  readonly formGroup = new FormGroup({
    // artist_name: new FormControl(''),
    // product_name: new FormControl(''),
    keyword: new FormControl<string | null>(null),
    stock_type: new FormControl<number | ''>(''),
    // product__status: new FormControl<number | ''>(''),
  });

  getApiQueryParams(params?: Partial<IManagedProductSearchParams>) {
    return {
      // artist_name: params?.artist_name ?? '',
      // product_name: params?.product_name ?? '',
      keyword: params?.keyword ?? '',
      stock_type: params?.stock_type ?? '',
      // product__status: params?.product__status ?? '',
      page: params?.page ?? 1,
    };
  }

  setSearchParams(params: Partial<IManagedProductSearchParams>) {
    this.formGroup.patchValue({
      // artist_name: params.artist_name ?? '',
      // product_name: params.product_name ?? '',
      keyword: params.keyword ?? null,
      stock_type: params.stock_type ? Number(params.stock_type) : '',
      // product__status: params.product__status ? Number(params.product__status) : '',
    });
  }
}
